// =========================================================
// Vojjin AJAX Utilities
// =========================================================

;(function (global) {
    // Create namespace
    const G = global.gemini || (global.gemini = {});
    G.net = {};


    /**
     * Fetch utility for Gemini framework.
     * Supports method, query params, body, headers, and error handling.
     *
     * @param {string} url - The endpoint URL
     * @param {Object} [options] - Optional configuration
     * @param {string} [options.method='GET'] - HTTP method
     * @param {Object} [options.query] - Query parameters (for GET-like requests)
     * @param {Object|string|FormData|null} [options.body] - Request payload
     * @param {Object} [options.headers] - Custom headers
     * @returns {Promise<Object>} - Resolves with parsed JSON or response text
     *
     * sample:
     * gemini.net.fetch("https://api.example.com/login", {
     *   method: "POST",
     *   body: { username: "traveler", password: "magic" },
     * }).then(data => {
     *   console.log("Success:", data);
     * }).catch(err => {
     *   console.error("Failed:", err);
     * });
     */
    G.net.fetch = async function (url, options = {}) {
        const {
            method = "GET",
            query = null,
            body = null,
            headers = {},
        } = options;

        try {
            // Construct query params if present
            let finalUrl = url;
            if (query && typeof query === "object") {
                const qs = new URLSearchParams(query).toString();
                finalUrl += (url.includes("?") ? "&" : "?") + qs;
            }

            // Default headers
            const finalHeaders = {
                "Content-Type": "application/json",
                ...headers,
            };

            // Prepare fetch options
            const fetchOptions = {
                method: method.toUpperCase(),
                headers: finalHeaders,
            };

            // Handle request body (JSON auto-stringify)
            if (body) {
                if (
                    finalHeaders["Content-Type"] &&
                    finalHeaders["Content-Type"].includes("application/json") &&
                    typeof body === "object" &&
                    !(body instanceof FormData)
                ) {
                    fetchOptions.body = JSON.stringify(body);
                } else {
                    fetchOptions.body = body;
                }
            }

            try {
                const response = await fetch(finalUrl, fetchOptions);

                // Check for network or HTTP errors
                if (!response.ok) {
                    const text = await response.text();
                    throw new Error(
                        `HTTP ${response.status} ${response.statusText}: ${text}`
                    );
                } else {
                    // Try to parse JSON automatically
                    const contentType = response.headers.get("content-type");
                    if (contentType && contentType.includes("application/json")) {
                        return await response.json();
                    } else {
                        return await response.text();
                    }
                }

            } catch (e) {
                console.log("Fetch failed at fetch() call:", e);
            }
        } catch (err) {
            throw err;
        }
    };

    G.net.get = (url, query, headers) =>
        G.net.fetch(url, {method: "GET", query: query, headers: headers});

    G.net.post = (url, body, headers) =>
        G.net.fetch(url, {method: "POST", body: body, headers: headers});


    if (typeof module !== "undefined" && module.exports) {
        module.exports = G.net;
    } else {
        global.gemini = G;
        global.gemini.net = G.net;
    }
})(typeof globalThis !== "undefined" ? globalThis : this);
